const PHASES_CONFIG = [
  {
    code: 'kickoff_phase',
    icon: 'stages-kickoff',
    estimatedTime: 'Pre-training setup: ~25 min'
  },
  {
    code: 'front_office_phase',
    icon: 'stages-frontoffice',
    estimatedTime: 'Pre-training setup: ~28 min'
  },
  {
    code: 'clinical_phase',
    icon: 'stages-clinical',
    estimatedTime: 'Pre-training setup: ~60 min'
  },
  {
    code: 'back_office_phase',
    icon: 'stages-backoffice',
    estimatedTime: 'Pre-training setup: ~35 min'
  },
  {
    code: 'hard_launch_phase',
    icon: 'stages-hardlaunch',
    estimatedTime: 'Pre-training setup: ~10 min'
  }
];

export default PHASES_CONFIG;
